import * as React from 'react';

import { ILocalization } from '@shared-ui/localization-context';
import { importLocale, L10nModule, withLocalization } from 'bernie-l10n';
import { ContextStore } from 'bernie-core';

export interface LocalizedTextWrappingProps {
  context?: ContextStore;
  l10n?: ILocalization;
  message?: string;
  fieldName?: string;
}

@withLocalization
export class LocalizedTextWrapping extends React.Component<LocalizedTextWrappingProps> {
  public render() {
    const outerText = this.props.l10n.formatText(this.props.message).split(`[${this.props.fieldName}]`);

    switch (outerText.length) {
      case 1:
        return outerText[0];

      case 2:
        return (
          <>
            {outerText[0]}
            {this.props.children}
            {outerText[1]}
          </>
        );

      default:
        throw new Error(`More than one field called ${this.props.fieldName}`);
    }
  }
}
